import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';

const SecondaryButton: React.FC<ButtonProps> = (props) => (
    <Button
        variant="outlined"
        sx={{
            backgroundColor: 'transparent',
            color: '#134F5C',
            fontWeight: 600,
            borderRadius: '999px',
            borderColor: '#90C6D0',
            paddingX: 3,
            paddingY: 1,
            textTransform: 'none',
            whiteSpace: 'nowrap',
            '&:hover': { borderColor: '#134F5C', backgroundColor: '#F3FBFA' },
        }}
        {...props}
    />
);

export default SecondaryButton;
